<template>
	<form @submit.prevent="onSubmitForm">
		<div class="in-progress-section divided">
			<textarea v-model="supportActionsDescription" :disabled="isDisabled" class="TextField" placeholder="De omschrijving van de acties die zijn ondernomen om de ticket op te lossen"></textarea>
			<span class="error-message" v-if="this.errors.includes('support_actions_description')">Mag niet leeg zijn</span>
		</div>
		<Button v-if="!isDisabled" class="primary submit button" :disabled="isLoading" type="submit" ref="submitButton">OPSLAAN</Button>
	</form>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { client } from "../../store";
import { validateNotEmptyOrEmptyString } from "../../common/validators";

export default {
	name: "InProgressDetail",

	computed: {
		...mapState({
			isLoading: "loading"
		})
	},

	props: {
		supportTicket: null,
		forceUpdate: null,
		isDisabled: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			supportActionsDescription: null,
			errors: []
		}
	},

	methods: {
		...mapActions({
			setLoading: "map/setLoading",
			setIdle: "map/setIdle"
		}),

		onSubmitForm() {
			if (this.isDisabled) {
				return;
			}

			if (validateNotEmptyOrEmptyString(this.supportActionsDescription) === false) {
				this.errors.push('support_actions_description')
				return;
			} else {
				this.errors = this.errors.filter(error => error !== 'support_actions_description');
			}

			this.setLoading();

			client.query(`
				mutation($support_ticket_id: ID!, $support_actions_description: String) {
					updateSupportTicket(support_ticket_id: $support_ticket_id, support_actions_description: $support_actions_description)
				}
			`, {
				support_ticket_id: this.supportTicket.id,
				support_actions_description: this.supportActionsDescription
			}).then(() => {
				this.$notify({
					group: "app",
					title: "Support ticket updaten",
					type: "success",
					text: "Support ticket is succesvol aangepast"
				});

				this.setIdle();
				this.forceUpdate();
			}).catch((error) => {
				this.setIdle();

				this.$notify({
					group: "app",
					title: "Status updaten",
					type: "error",
					text: error
				});
			});
		}
	},

	beforeMount() {
		this.supportActionsDescription = this.supportTicket.support_actions_description;
	}
}
</script>

<style scoped lang="scss">

.button {
	text-align: center;
	padding: 8px 12px;
	border-radius: 4px;
	font-size: 1em;
	display: inline;
	font-weight: 425;
	width: 100%;

	background-color: #35a5a4;
	color: white;
	border: none;
}

textarea {
	width: 100%;
	height: 200px;
	margin: 0;
	border: 2px solid #d2d2d2;
	box-shadow: none;
	border-radius: 4px;
	color: #666;
	background-color: #fff;
}

textarea:focus {
	background-color: #fff;
}

form {
	display: flex;
	flex-direction: column;
	gap: 24px;
}

.primary.submit.button {
	width: 20%;
	align-self: end;
}

.in-progress-section {
	padding-top: 24px;
}

.divided {
	border-top: 2px solid #d2d2d2;
	margin-top: 24px;
}

.error-message {
	display: block;
	margin-top: 8px;
	color: red;
}
</style>
